/*
 *
 * PlatePanel actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { PaneMaterial } from 'lib/modelBuilder/constants';
import { Color } from 'lib/modelBuilder/entities/Color';

export const displayPlatePanelAction = (value: boolean, top = false) =>
  action(ActionTypes.DISPLAY_PLATE_PANEL, { value, top });

export const addPlateAction = () => action(ActionTypes.ADD_PLATE);
export const removePlateAction = (top?: boolean) =>
  action(ActionTypes.REMOVE_PLATE, { top });
export const updatePlateAction = (
  glass?: boolean,
  material?: PaneMaterial,
  color?: Color,
  preview?: boolean,
  updateTopPlate?: boolean,
  updateShelvesPlates = true,
) =>
  action(ActionTypes.UPDATE_PLATE, {
    glass,
    material,
    color,
    preview,
    updateTopPlate,
    updateShelvesPlates,
  });
